import styled from 'styled-components';
import { Select, WarningNotice } from '@studio/legacy-components';

export const URLList = styled.ul`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const URLSelectWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const SelectField = styled.div`
  width: 90%;

  ${Select} {
    max-width: inherit;
  }
`;

export const URLNotice = styled(WarningNotice)`
  margin-top: 16px;
`;
